import { DEFAULT_LANGUAGE } from '../i18n/constants';
import { analytics } from '../services/analytics';
import soundEffects from '../services/sounds/soundEffects';
import type { Category } from '../stores/categories/CategoriesStore';
import { useStores } from '../stores/useStores';

export function useSelectCategory() {
  const { categoriesStore, gamesSearchStore } = useStores();

  const selectCategory = (id: Category['masterGameSubCategoryId']) => {
    const category = categoriesStore.categoriesRegistry[id];
    categoriesStore.selectCategory(id);
    gamesSearchStore.closeSearch();
    void analytics.sendEvent('lobby_games_filter', {
      category_id: category?.masterGameSubCategoryId,
      category_name: category?.name[DEFAULT_LANGUAGE] || 'home',
    });
    soundEffects.playSound('click');
  };

  return {
    selectCategory,
  };
}
